export const SET_USER_REQUEST = "SET_USER_REQUEST";

export const POST_BOOKING_DETAIL = "post/booking/detail";
export const GET_BOOKING_DETAIL = "get/booking/detail";
export const DELETE_BOOKING_DETAIL = "delete/booking/detail";
